import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ErrorService {
  errorSubject = new BehaviorSubject<HttpErrorResponse>(null);

  notify(err: HttpErrorResponse) {
    this.errorSubject.next(err);
  }
}
